import {combineEpics} from 'web-app/util/redux-observable';

import filtersAndColumnsEpics from './filters-and-columns/epics';
import resultsEpics from './results/epics';

export default combineEpics(filtersAndColumnsEpics, resultsEpics);
